import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "value", "output"]
  static values = { rates: Object, assumptions: Object }

  connect() {
    this.render()
  }

  update() {
    this.render()
    const detail = { credits: this.credits }
    this.element.dispatchEvent(new CustomEvent("credit-estimate:change", { bubbles: true, detail }))
  }

  render() {
    this.inputTargets.forEach((input, index) => (this.valueTargets[index].textContent = input.value))
    this.outputTarget.value = this.credits.toLocaleString()
  }

  get credits() {
    const amount = this.usage.reduce((sum, [event, quantity]) => {
      const rate = this.ratesValue[event]
      return sum + (quantity / rate.per) * rate.amount
    }, 0)
    return Math.round(Math.abs(amount))
  }

  get usage() {
    const { team_count, people_per_team, goals_per_team, echoes_per_person } = this.inputs
    const {
      weeks_per_month,
      check_in_days_per_week,
      check_in_participation_percent,
      goal_participation_percent,
      basic_tokens_per_person_per_week,
      advanced_tokens_per_echo_answer,
    } = this.assumptionsValue
    const person_count = team_count * people_per_team
    const check_ins_per_person = weeks_per_month * check_in_days_per_week * (check_in_participation_percent / 100)
    const echo_answer_count = person_count * echoes_per_person * weeks_per_month

    return Object.entries({
      check_in_delivery: person_count * people_per_team * check_ins_per_person,
      summary_delivery: person_count * check_ins_per_person,
      goal_delivery: person_count * goals_per_team * weeks_per_month * (goal_participation_percent / 100),
      echo_delivery: echo_answer_count,
      basic_ai_tokens: person_count * basic_tokens_per_person_per_week * weeks_per_month,
      advanced_ai_tokens: echo_answer_count * advanced_tokens_per_echo_answer,
    })
  }

  get inputs() {
    return Object.fromEntries(this.inputTargets.map((input) => [input.dataset.input, Number(input.value)]))
  }
}
